/**
 * Settings → Test drive documents.
 *
 * The documents a customer reads and accepts at the Agreement step of a test
 * drive check-in. Read-only for now: they are sample placeholders until the
 * dealership confirms its real forms, and they come from
 * lib/testDriveDocuments.js — the same list the check-in screen uses.
 */
import { TEST_DRIVE_DOCUMENTS } from '../../lib/testDriveDocuments';

export default function TestDriveDocumentsPanel() {
  return (
    <div className="flex-col" style={{ gap: 14 }}>
      <div className="card animate-in">
        <div style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 16, fontWeight: 600 }}>Test drive documents</div>
          <div className="mono text-xs text-muted" style={{ marginTop: 4, lineHeight: 1.6 }}>
            Shown to the customer on the Agreement step when a test drive starts. They read and
            accept these before signing.
          </div>
        </div>

        <div style={{
          display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 12, marginBottom: 14,
          border: '1px solid var(--warning)', borderRadius: 8, padding: '8px 10px',
          background: 'color-mix(in srgb, var(--warning) 10%, transparent)',
        }}>
          <span aria-hidden>ℹ</span>
          <span>
            These are <strong>sample documents</strong> for demonstration only. They will be replaced
            with the dealership&rsquo;s approved forms.
          </span>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 12 }}>
          {TEST_DRIVE_DOCUMENTS.map((d, i) => (
            <div key={d.id} className="card" style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <div className="mono text-xs text-muted">DOCUMENT {i + 1} · PDF</div>
              <div style={{ fontSize: 14, fontWeight: 600, lineHeight: 1.35 }}>📄 {d.title}</div>
              <div className="text-xs text-muted" style={{ lineHeight: 1.5, flex: 1 }}>{d.description}</div>
              <div style={{ display: 'flex', gap: 6 }}>
                <a className="btn small primary" href={d.file} target="_blank" rel="noopener noreferrer">View</a>
                <a className="btn small" href={d.file} download>Download</a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
